import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private labels = new BehaviorSubject<{ [key: string]: string }>({});

  public setLabel(segment: string, label: string) {
    const current = this.labels.value;
    if (current[segment] === label) {
      return;
    }
    this.labels.next({ ...current, [segment]: label });
  }

  public getLabels() {
    return this.labels.asObservable();
  }
}
